<template>
  <router-view />
  <!-- <body>
    <main-section />

    <div class="border"></div>
    <about-section />
    <div class="border"></div>
    <projects-section />

    <footer></footer>
    <scroll-to-top />
    <a class="returnButton" v-show="scY >1000" href="#Top"><i class="fas fa-angle-up fab"></i></a>
  </body> -->
</template>

<script>
import 'animate.css';
// import MainSection from './components/MainSection.vue';
// import ProjectsSection from './components/ProjectsSection.vue';
// import AboutSection from './components/AboutSection.vue';
// import ScrollToTop from './components/scrollToTop.vue';

export default {
  name: 'App',
};
</script>

<style>
#app {
  color: white;
  text-align: center;
}
/* h1 { font-size: 4.5rem; line-height: 1;  text-shadow: 3px 3px 0px black;}
h2 { font-size: 3.75rem; line-height: 1;  text-shadow: 3px 3px 0px black;}
h3 { font-size: 3rem; line-height: 1;  text-shadow: 3px 3px 0px black;}
p {font-size: 1.25rem; line-height: 1.75rem;}
h1,h2,h3,p { margin: 0;} */
/* h4 { font-size: 2.25rem;}
h5 { font-size: 4.5rem;} */
* {
}
h1 {
  font-size: 20vw;
  text-shadow: 0.5vw 0.5vw black;
  /* padding-top: 10vh; */
  margin: 0px;
  line-height: 1;
}
h2 {
  font-size: 17.5vw;
  margin: 0;
  text-shadow: 0.5vw 0.5vw black;
  line-height: 1;
}
@media (orientation: landscape) {
  h1 {
    font-size: 20vh; /* 15vh */
    text-shadow: 0.5vh 0.5vh black;
  }
  h2 {
    font-size: 15vh;
    margin: 0;
    text-shadow: 0.5vh 0.5vh black;
  }
}

html {
  font-family: 'Raleway', sans-serif;
  font-family: 'Oswald', sans-serif;
  /* font-size: 16px; */
  /* scroll-behavior: smooth; */
  min-width: 360px;
}
body {
  margin: 0px;
  min-width: 360px;
}
main {
  /* height: 100vh; */
  justify-content: center;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* background-image: linear-gradient(45deg, rgba(194,194,194, 0.2) 0%, rgba(194,194,194, 0.2) 14.286%,rgba(182,182,182, 0.2) 14.286%, rgba(182,182,182, 0.2) 28.572%,rgba(201,201,201, 0.2) 28.572%, rgba(201,201,201, 0.2) 42.858%,rgba(176,176,176, 0.2) 42.858%, rgba(176,176,176, 0.2) 57.144%,rgba(174,174,174, 0.2) 57.144%, rgba(174,174,174, 0.2) 71.43%,rgba(255,238,238, 0.2) 71.43%, rgba(255,238,238, 0.2) 85.716%,rgba(183,183,183, 0.2) 85.716%, rgba(183,183,183, 0.2) 100.002%),linear-gradient(45deg, rgba(194,194,194, 0.2) 0%, rgba(194,194,194, 0.2) 14.286%,rgba(182,182,182, 0.2) 14.286%, rgba(182,182,182, 0.2) 28.572%,rgba(201,201,201, 0.2) 28.572%, rgba(201,201,201, 0.2) 42.858%,rgba(176,176,176, 0.2) 42.858%, rgba(176,176,176, 0.2) 57.144%,rgba(174,174,174, 0.2) 57.144%, rgba(174,174,174, 0.2) 71.43%,rgba(255,238,238, 0.2) 71.43%, rgba(255,238,238, 0.2) 85.716%,rgba(183,183,183, 0.2) 85.716%, rgba(183,183,183, 0.2) 100.002%),linear-gradient(135deg, rgba(194,194,194, 0.2) 0%, rgba(194,194,194, 0.2) 14.286%,rgba(182,182,182, 0.2) 14.286%, rgba(182,182,182, 0.2) 28.572%,rgba(201,201,201, 0.2) 28.572%, rgba(201,201,201, 0.2) 42.858%,rgba(176,176,176, 0.2) 42.858%, rgba(176,176,176, 0.2) 57.144%,rgba(174,174,174, 0.2) 57.144%, rgba(174,174,174, 0.2) 71.43%,rgba(255,238,238, 0.2) 71.43%, rgba(255,238,238, 0.2) 85.716%,rgba(183,183,183, 0.2) 85.716%, rgba(183,183,183, 0.2) 100.002%),linear-gradient(90deg, rgb(255,255,255),rgb(255,255,255)); */
  background: linear-gradient(
      71deg,
      rgba(55, 55, 55, 0.03) 0%,
      rgba(55, 55, 55, 0.03) 16.667%,
      rgba(111, 111, 111, 0.03) 16.667%,
      rgba(111, 111, 111, 0.03) 33.334%,
      rgba(230, 230, 230, 0.03) 33.334%,
      rgba(230, 230, 230, 0.03) 50.001000000000005%,
      rgba(129, 129, 129, 0.03) 50.001%,
      rgba(129, 129, 129, 0.03) 66.668%,
      rgba(77, 77, 77, 0.03) 66.668%,
      rgba(77, 77, 77, 0.03) 83.33500000000001%,
      rgba(190, 190, 190, 0.03) 83.335%,
      rgba(190, 190, 190, 0.03) 100.002%
    ),
    linear-gradient(
      281deg,
      rgba(176, 176, 176, 0.03) 0%,
      rgba(176, 176, 176, 0.03) 16.667%,
      rgba(192, 192, 192, 0.03) 16.667%,
      rgba(192, 192, 192, 0.03) 33.334%,
      rgba(74, 74, 74, 0.03) 33.334%,
      rgba(74, 74, 74, 0.03) 50.001000000000005%,
      rgba(169, 169, 169, 0.03) 50.001%,
      rgba(169, 169, 169, 0.03) 66.668%,
      rgba(34, 34, 34, 0.03) 66.668%,
      rgba(34, 34, 34, 0.03) 83.33500000000001%,
      rgba(5, 5, 5, 0.03) 83.335%,
      rgba(5, 5, 5, 0.03) 100.002%
    ),
    linear-gradient(
      196deg,
      rgba(98, 98, 98, 0.03) 0%,
      rgba(98, 98, 98, 0.03) 16.667%,
      rgba(208, 208, 208, 0.03) 16.667%,
      rgba(208, 208, 208, 0.03) 33.334%,
      rgba(63, 63, 63, 0.03) 33.334%,
      rgba(63, 63, 63, 0.03) 50.001000000000005%,
      rgba(180, 180, 180, 0.03) 50.001%,
      rgba(180, 180, 180, 0.03) 66.668%,
      rgba(200, 200, 200, 0.03) 66.668%,
      rgba(200, 200, 200, 0.03) 83.33500000000001%,
      rgba(59, 59, 59, 0.03) 83.335%,
      rgba(59, 59, 59, 0.03) 100.002%
    ),
    linear-gradient(
      35deg,
      rgba(233, 233, 233, 0.03) 0%,
      rgba(233, 233, 233, 0.03) 16.667%,
      rgba(26, 26, 26, 0.03) 16.667%,
      rgba(26, 26, 26, 0.03) 33.334%,
      rgba(186, 186, 186, 0.03) 33.334%,
      rgba(186, 186, 186, 0.03) 50.001000000000005%,
      rgba(162, 162, 162, 0.03) 50.001%,
      rgba(162, 162, 162, 0.03) 66.668%,
      rgba(254, 254, 254, 0.03) 66.668%,
      rgba(254, 254, 254, 0.03) 83.33500000000001%,
      rgba(245, 245, 245, 0.03) 83.335%,
      rgba(245, 245, 245, 0.03) 100.002%
    ),
    linear-gradient(
      294deg,
      rgba(157, 157, 157, 0.01) 0%,
      rgba(157, 157, 157, 0.01) 12.5%,
      rgba(125, 125, 125, 0.01) 12.5%,
      rgba(125, 125, 125, 0.01) 25%,
      rgba(120, 120, 120, 0.01) 25%,
      rgba(120, 120, 120, 0.01) 37.5%,
      rgba(19, 19, 19, 0.01) 37.5%,
      rgba(19, 19, 19, 0.01) 50%,
      rgba(111, 111, 111, 0.01) 50%,
      rgba(111, 111, 111, 0.01) 62.5%,
      rgba(140, 140, 140, 0.01) 62.5%,
      rgba(140, 140, 140, 0.01) 75%,
      rgba(114, 114, 114, 0.01) 75%,
      rgba(114, 114, 114, 0.01) 87.5%,
      rgba(94, 94, 94, 0.01) 87.5%,
      rgba(94, 94, 94, 0.01) 100%
    ),
    linear-gradient(
      19deg,
      rgba(217, 217, 217, 0.02) 0%,
      rgba(217, 217, 217, 0.02) 20%,
      rgba(105, 105, 105, 0.02) 20%,
      rgba(105, 105, 105, 0.02) 40%,
      rgba(252, 252, 252, 0.02) 40%,
      rgba(252, 252, 252, 0.02) 60%,
      rgba(1, 1, 1, 0.02) 60%,
      rgba(1, 1, 1, 0.02) 80%,
      rgba(232, 232, 232, 0.02) 80%,
      rgba(232, 232, 232, 0.02) 100%
    ),
    linear-gradient(90deg, rgb(22, 94, 235), rgb(126, 195, 9));
    background-image: repeating-linear-gradient(405deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(405deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(405deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(157.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),linear-gradient(360deg, rgb(126,195,9),rgb(22,94,235));
  background-image: repeating-linear-gradient(405deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(405deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(405deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(157.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),linear-gradient(360deg, rgb(22,94,235),rgb(57, 199, 205));
  /* background-image: linear-gradient(71deg, rgba(55, 55, 55, 0.03) 0%, rgba(55, 55, 55, 0.03) 16.667%,rgba(111, 111, 111, 0.03) 16.667%, rgba(111, 111, 111, 0.03) 33.334%,rgba(230, 230, 230, 0.03) 33.334%, rgba(230, 230, 230, 0.03) 50.001000000000005%,rgba(129, 129, 129, 0.03) 50.001%, rgba(129, 129, 129, 0.03) 66.668%,rgba(77, 77, 77, 0.03) 66.668%, rgba(77, 77, 77, 0.03) 83.33500000000001%,rgba(190, 190, 190, 0.03) 83.335%, rgba(190, 190, 190, 0.03) 100.002%),linear-gradient(281deg, rgba(176, 176, 176, 0.03) 0%, rgba(176, 176, 176, 0.03) 16.667%,rgba(192, 192, 192, 0.03) 16.667%, rgba(192, 192, 192, 0.03) 33.334%,rgba(74, 74, 74, 0.03) 33.334%, rgba(74, 74, 74, 0.03) 50.001000000000005%,rgba(169, 169, 169, 0.03) 50.001%, rgba(169, 169, 169, 0.03) 66.668%,rgba(34, 34, 34, 0.03) 66.668%, rgba(34, 34, 34, 0.03) 83.33500000000001%,rgba(5, 5, 5, 0.03) 83.335%, rgba(5, 5, 5, 0.03) 100.002%),linear-gradient(196deg, rgba(98, 98, 98, 0.03) 0%, rgba(98, 98, 98, 0.03) 16.667%,rgba(208, 208, 208, 0.03) 16.667%, rgba(208, 208, 208, 0.03) 33.334%,rgba(63, 63, 63, 0.03) 33.334%, rgba(63, 63, 63, 0.03) 50.001000000000005%,rgba(180, 180, 180, 0.03) 50.001%, rgba(180, 180, 180, 0.03) 66.668%,rgba(200, 200, 200, 0.03) 66.668%, rgba(200, 200, 200, 0.03) 83.33500000000001%,rgba(59, 59, 59, 0.03) 83.335%, rgba(59, 59, 59, 0.03) 100.002%),linear-gradient(35deg, rgba(233, 233, 233, 0.03) 0%, rgba(233, 233, 233, 0.03) 16.667%,rgba(26, 26, 26, 0.03) 16.667%, rgba(26, 26, 26, 0.03) 33.334%,rgba(186, 186, 186, 0.03) 33.334%, rgba(186, 186, 186, 0.03) 50.001000000000005%,rgba(162, 162, 162, 0.03) 50.001%, rgba(162, 162, 162, 0.03) 66.668%,rgba(254, 254, 254, 0.03) 66.668%, rgba(254, 254, 254, 0.03) 83.33500000000001%,rgba(245, 245, 245, 0.03) 83.335%, rgba(245, 245, 245, 0.03) 100.002%),linear-gradient(294deg, rgba(157, 157, 157, 0.01) 0%, rgba(157, 157, 157, 0.01) 12.5%,rgba(125, 125, 125, 0.01) 12.5%, rgba(125, 125, 125, 0.01) 25%,rgba(120, 120, 120, 0.01) 25%, rgba(120, 120, 120, 0.01) 37.5%,rgba(19, 19, 19, 0.01) 37.5%, rgba(19, 19, 19, 0.01) 50%,rgba(111, 111, 111, 0.01) 50%, rgba(111, 111, 111, 0.01) 62.5%,rgba(140, 140, 140, 0.01) 62.5%, rgba(140, 140, 140, 0.01) 75%,rgba(114, 114, 114, 0.01) 75%, rgba(114, 114, 114, 0.01) 87.5%,rgba(94, 94, 94, 0.01) 87.5%, rgba(94, 94, 94, 0.01) 100%),linear-gradient(19deg, rgba(217, 217, 217, 0.02) 0%, rgba(217, 217, 217, 0.02) 20%,rgba(105, 105, 105, 0.02) 20%, rgba(105, 105, 105, 0.02) 40%,rgba(252, 252, 252, 0.02) 40%, rgba(252, 252, 252, 0.02) 60%,rgba(1, 1, 1, 0.02) 60%, rgba(1, 1, 1, 0.02) 80%,rgba(232, 232, 232, 0.02) 80%, rgba(232, 232, 232, 0.02) 100%),linear-gradient(90deg, rgb(22, 94, 235),rgb(22,94,235)); */
  background-attachment: fixed;
  /* animation: gradient 15s ease infinite; */
  /* background-size: 150%; */
}
@keyframes gradient {
  0% {
    /* background linear-gradient(71deg, rgba(55, 55, 55, 0.03) 0%, rgba(55, 55, 55, 0.03) 16.667%,rgba(111, 111, 111, 0.03) 16.667%, rgba(111, 111, 111, 0.03) 33.334%,rgba(230, 230, 230, 0.03) 33.334%, rgba(230, 230, 230, 0.03) 50.001000000000005%,rgba(129, 129, 129, 0.03) 50.001%, rgba(129, 129, 129, 0.03) 66.668%,rgba(77, 77, 77, 0.03) 66.668%, rgba(77, 77, 77, 0.03) 83.33500000000001%,rgba(190, 190, 190, 0.03) 83.335%, rgba(190, 190, 190, 0.03) 100.002%),linear-gradient(281deg, rgba(176, 176, 176, 0.03) 0%, rgba(176, 176, 176, 0.03) 16.667%,rgba(192, 192, 192, 0.03) 16.667%, rgba(192, 192, 192, 0.03) 33.334%,rgba(74, 74, 74, 0.03) 33.334%, rgba(74, 74, 74, 0.03) 50.001000000000005%,rgba(169, 169, 169, 0.03) 50.001%, rgba(169, 169, 169, 0.03) 66.668%,rgba(34, 34, 34, 0.03) 66.668%, rgba(34, 34, 34, 0.03) 83.33500000000001%,rgba(5, 5, 5, 0.03) 83.335%, rgba(5, 5, 5, 0.03) 100.002%),linear-gradient(196deg, rgba(98, 98, 98, 0.03) 0%, rgba(98, 98, 98, 0.03) 16.667%,rgba(208, 208, 208, 0.03) 16.667%, rgba(208, 208, 208, 0.03) 33.334%,rgba(63, 63, 63, 0.03) 33.334%, rgba(63, 63, 63, 0.03) 50.001000000000005%,rgba(180, 180, 180, 0.03) 50.001%, rgba(180, 180, 180, 0.03) 66.668%,rgba(200, 200, 200, 0.03) 66.668%, rgba(200, 200, 200, 0.03) 83.33500000000001%,rgba(59, 59, 59, 0.03) 83.335%, rgba(59, 59, 59, 0.03) 100.002%),linear-gradient(35deg, rgba(233, 233, 233, 0.03) 0%, rgba(233, 233, 233, 0.03) 16.667%,rgba(26, 26, 26, 0.03) 16.667%, rgba(26, 26, 26, 0.03) 33.334%,rgba(186, 186, 186, 0.03) 33.334%, rgba(186, 186, 186, 0.03) 50.001000000000005%,rgba(162, 162, 162, 0.03) 50.001%, rgba(162, 162, 162, 0.03) 66.668%,rgba(254, 254, 254, 0.03) 66.668%, rgba(254, 254, 254, 0.03) 83.33500000000001%,rgba(245, 245, 245, 0.03) 83.335%, rgba(245, 245, 245, 0.03) 100.002%),linear-gradient(294deg, rgba(157, 157, 157, 0.01) 0%, rgba(157, 157, 157, 0.01) 12.5%,rgba(125, 125, 125, 0.01) 12.5%, rgba(125, 125, 125, 0.01) 25%,rgba(120, 120, 120, 0.01) 25%, rgba(120, 120, 120, 0.01) 37.5%,rgba(19, 19, 19, 0.01) 37.5%, rgba(19, 19, 19, 0.01) 50%,rgba(111, 111, 111, 0.01) 50%, rgba(111, 111, 111, 0.01) 62.5%,rgba(140, 140, 140, 0.01) 62.5%, rgba(140, 140, 140, 0.01) 75%,rgba(114, 114, 114, 0.01) 75%, rgba(114, 114, 114, 0.01) 87.5%,rgba(94, 94, 94, 0.01) 87.5%, rgba(94, 94, 94, 0.01) 100%),linear-gradient(19deg, rgba(217, 217, 217, 0.02) 0%, rgba(217, 217, 217, 0.02) 20%,rgba(105, 105, 105, 0.02) 20%, rgba(105, 105, 105, 0.02) 40%,rgba(252, 252, 252, 0.02) 40%, rgba(252, 252, 252, 0.02) 60%,rgba(1, 1, 1, 0.02) 60%, rgba(1, 1, 1, 0.02) 80%,rgba(232, 232, 232, 0.02) 80%, rgba(232, 232, 232, 0.02) 100%),linear-gradient(90deg, rgb(22, 94, 235),rgb(22,94,235)); */
    background-position: 0% 50%;
    /* background-size: 100%; */
  }
  50% {
    /* background-image: linear-gradient(71deg, rgba(55, 55, 55, 0.03) 0%, rgba(55, 55, 55, 0.03) 16.667%,rgba(111, 111, 111, 0.03) 16.667%, rgba(111, 111, 111, 0.03) 33.334%,rgba(230, 230, 230, 0.03) 33.334%, rgba(230, 230, 230, 0.03) 50.001000000000005%,rgba(129, 129, 129, 0.03) 50.001%, rgba(129, 129, 129, 0.03) 66.668%,rgba(77, 77, 77, 0.03) 66.668%, rgba(77, 77, 77, 0.03) 83.33500000000001%,rgba(190, 190, 190, 0.03) 83.335%, rgba(190, 190, 190, 0.03) 100.002%),linear-gradient(281deg, rgba(176, 176, 176, 0.03) 0%, rgba(176, 176, 176, 0.03) 16.667%,rgba(192, 192, 192, 0.03) 16.667%, rgba(192, 192, 192, 0.03) 33.334%,rgba(74, 74, 74, 0.03) 33.334%, rgba(74, 74, 74, 0.03) 50.001000000000005%,rgba(169, 169, 169, 0.03) 50.001%, rgba(169, 169, 169, 0.03) 66.668%,rgba(34, 34, 34, 0.03) 66.668%, rgba(34, 34, 34, 0.03) 83.33500000000001%,rgba(5, 5, 5, 0.03) 83.335%, rgba(5, 5, 5, 0.03) 100.002%),linear-gradient(196deg, rgba(98, 98, 98, 0.03) 0%, rgba(98, 98, 98, 0.03) 16.667%,rgba(208, 208, 208, 0.03) 16.667%, rgba(208, 208, 208, 0.03) 33.334%,rgba(63, 63, 63, 0.03) 33.334%, rgba(63, 63, 63, 0.03) 50.001000000000005%,rgba(180, 180, 180, 0.03) 50.001%, rgba(180, 180, 180, 0.03) 66.668%,rgba(200, 200, 200, 0.03) 66.668%, rgba(200, 200, 200, 0.03) 83.33500000000001%,rgba(59, 59, 59, 0.03) 83.335%, rgba(59, 59, 59, 0.03) 100.002%),linear-gradient(35deg, rgba(233, 233, 233, 0.03) 0%, rgba(233, 233, 233, 0.03) 16.667%,rgba(26, 26, 26, 0.03) 16.667%, rgba(26, 26, 26, 0.03) 33.334%,rgba(186, 186, 186, 0.03) 33.334%, rgba(186, 186, 186, 0.03) 50.001000000000005%,rgba(162, 162, 162, 0.03) 50.001%, rgba(162, 162, 162, 0.03) 66.668%,rgba(254, 254, 254, 0.03) 66.668%, rgba(254, 254, 254, 0.03) 83.33500000000001%,rgba(245, 245, 245, 0.03) 83.335%, rgba(245, 245, 245, 0.03) 100.002%),linear-gradient(294deg, rgba(157, 157, 157, 0.01) 0%, rgba(157, 157, 157, 0.01) 12.5%,rgba(125, 125, 125, 0.01) 12.5%, rgba(125, 125, 125, 0.01) 25%,rgba(120, 120, 120, 0.01) 25%, rgba(120, 120, 120, 0.01) 37.5%,rgba(19, 19, 19, 0.01) 37.5%, rgba(19, 19, 19, 0.01) 50%,rgba(111, 111, 111, 0.01) 50%, rgba(111, 111, 111, 0.01) 62.5%,rgba(140, 140, 140, 0.01) 62.5%, rgba(140, 140, 140, 0.01) 75%,rgba(114, 114, 114, 0.01) 75%, rgba(114, 114, 114, 0.01) 87.5%,rgba(94, 94, 94, 0.01) 87.5%, rgba(94, 94, 94, 0.01) 100%),linear-gradient(19deg, rgba(217, 217, 217, 0.02) 0%, rgba(217, 217, 217, 0.02) 20%,rgba(105, 105, 105, 0.02) 20%, rgba(105, 105, 105, 0.02) 40%,rgba(252, 252, 252, 0.02) 40%, rgba(252, 252, 252, 0.02) 60%,rgba(1, 1, 1, 0.02) 60%, rgba(1, 1, 1, 0.02) 80%,rgba(232, 232, 232, 0.02) 80%, rgba(232, 232, 232, 0.02) 100%),linear-gradient(90deg, rgb(22, 94, 235),rgb(126, 195, 9)); */
    background-position: 100% 50%;
  }
  100% {
    /* background-image: linear-gradient(71deg, rgba(55, 55, 55, 0.03) 0%, rgba(55, 55, 55, 0.03) 16.667%,rgba(111, 111, 111, 0.03) 16.667%, rgba(111, 111, 111, 0.03) 33.334%,rgba(230, 230, 230, 0.03) 33.334%, rgba(230, 230, 230, 0.03) 50.001000000000005%,rgba(129, 129, 129, 0.03) 50.001%, rgba(129, 129, 129, 0.03) 66.668%,rgba(77, 77, 77, 0.03) 66.668%, rgba(77, 77, 77, 0.03) 83.33500000000001%,rgba(190, 190, 190, 0.03) 83.335%, rgba(190, 190, 190, 0.03) 100.002%),linear-gradient(281deg, rgba(176, 176, 176, 0.03) 0%, rgba(176, 176, 176, 0.03) 16.667%,rgba(192, 192, 192, 0.03) 16.667%, rgba(192, 192, 192, 0.03) 33.334%,rgba(74, 74, 74, 0.03) 33.334%, rgba(74, 74, 74, 0.03) 50.001000000000005%,rgba(169, 169, 169, 0.03) 50.001%, rgba(169, 169, 169, 0.03) 66.668%,rgba(34, 34, 34, 0.03) 66.668%, rgba(34, 34, 34, 0.03) 83.33500000000001%,rgba(5, 5, 5, 0.03) 83.335%, rgba(5, 5, 5, 0.03) 100.002%),linear-gradient(196deg, rgba(98, 98, 98, 0.03) 0%, rgba(98, 98, 98, 0.03) 16.667%,rgba(208, 208, 208, 0.03) 16.667%, rgba(208, 208, 208, 0.03) 33.334%,rgba(63, 63, 63, 0.03) 33.334%, rgba(63, 63, 63, 0.03) 50.001000000000005%,rgba(180, 180, 180, 0.03) 50.001%, rgba(180, 180, 180, 0.03) 66.668%,rgba(200, 200, 200, 0.03) 66.668%, rgba(200, 200, 200, 0.03) 83.33500000000001%,rgba(59, 59, 59, 0.03) 83.335%, rgba(59, 59, 59, 0.03) 100.002%),linear-gradient(35deg, rgba(233, 233, 233, 0.03) 0%, rgba(233, 233, 233, 0.03) 16.667%,rgba(26, 26, 26, 0.03) 16.667%, rgba(26, 26, 26, 0.03) 33.334%,rgba(186, 186, 186, 0.03) 33.334%, rgba(186, 186, 186, 0.03) 50.001000000000005%,rgba(162, 162, 162, 0.03) 50.001%, rgba(162, 162, 162, 0.03) 66.668%,rgba(254, 254, 254, 0.03) 66.668%, rgba(254, 254, 254, 0.03) 83.33500000000001%,rgba(245, 245, 245, 0.03) 83.335%, rgba(245, 245, 245, 0.03) 100.002%),linear-gradient(294deg, rgba(157, 157, 157, 0.01) 0%, rgba(157, 157, 157, 0.01) 12.5%,rgba(125, 125, 125, 0.01) 12.5%, rgba(125, 125, 125, 0.01) 25%,rgba(120, 120, 120, 0.01) 25%, rgba(120, 120, 120, 0.01) 37.5%,rgba(19, 19, 19, 0.01) 37.5%, rgba(19, 19, 19, 0.01) 50%,rgba(111, 111, 111, 0.01) 50%, rgba(111, 111, 111, 0.01) 62.5%,rgba(140, 140, 140, 0.01) 62.5%, rgba(140, 140, 140, 0.01) 75%,rgba(114, 114, 114, 0.01) 75%, rgba(114, 114, 114, 0.01) 87.5%,rgba(94, 94, 94, 0.01) 87.5%, rgba(94, 94, 94, 0.01) 100%),linear-gradient(19deg, rgba(217, 217, 217, 0.02) 0%, rgba(217, 217, 217, 0.02) 20%,rgba(105, 105, 105, 0.02) 20%, rgba(105, 105, 105, 0.02) 40%,rgba(252, 252, 252, 0.02) 40%, rgba(252, 252, 252, 0.02) 60%,rgba(1, 1, 1, 0.02) 60%, rgba(1, 1, 1, 0.02) 80%,rgba(232, 232, 232, 0.02) 80%, rgba(232, 232, 232, 0.02) 100%),linear-gradient(90deg, rgb(22, 94, 235),rgb(22,94,235)); */
    background-position: 0% 50%;
  }
}
.AboutSection {
  background: linear-gradient(
      52deg,
      rgba(163, 163, 163, 0.09) 0%,
      rgba(163, 163, 163, 0.09) 33.3%,
      rgba(100, 100, 100, 0.09) 33.3%,
      rgba(100, 100, 100, 0.09) 66.6%,
      rgba(162, 162, 162, 0.09) 66.6%,
      rgba(162, 162, 162, 0.09) 99%
    ),
    linear-gradient(
      258deg,
      rgba(193, 193, 193, 0.06) 0%,
      rgba(193, 193, 193, 0.06) 33.3%,
      rgba(169, 169, 169, 0.06) 33.3%,
      rgba(169, 169, 169, 0.06) 66.6%,
      rgba(92, 92, 92, 0.06) 66.6%,
      rgba(92, 92, 92, 0.06) 99%
    ),
    linear-gradient(
      129deg,
      rgba(45, 45, 45, 0.03) 0%,
      rgba(45, 45, 45, 0.03) 33.3%,
      rgba(223, 223, 223, 0.03) 33.3%,
      rgba(223, 223, 223, 0.03) 66.6%,
      rgba(173, 173, 173, 0.03) 66.6%,
      rgba(173, 173, 173, 0.03) 99%
    ),
    linear-gradient(
      280deg,
      rgba(226, 226, 226, 0.06) 0%,
      rgba(226, 226, 226, 0.06) 33.3%,
      rgba(81, 81, 81, 0.06) 33.3%,
      rgba(81, 81, 81, 0.06) 66.6%,
      rgba(186, 186, 186, 0.06) 66.6%,
      rgba(186, 186, 186, 0.06) 99%
    ),
    linear-gradient(
      85deg,
      rgba(225, 225, 225, 0.04) 0%,
      rgba(225, 225, 225, 0.04) 33.3%,
      rgba(95, 95, 95, 0.04) 33.3%,
      rgba(95, 95, 95, 0.04) 66.6%,
      rgba(39, 39, 39, 0.04) 66.6%,
      rgba(39, 39, 39, 0.04) 99%
    ),
    linear-gradient(
      128deg,
      rgba(184, 184, 184, 0.06) 0%,
      rgba(184, 184, 184, 0.06) 33.3%,
      rgba(0, 0, 0, 0.06) 33.3%,
      rgba(0, 0, 0, 0.06) 66.6%,
      rgba(140, 140, 140, 0.06) 66.6%,
      rgba(140, 140, 140, 0.06) 99.89999999999999%
    ),
    linear-gradient(
      323deg,
      rgba(40, 40, 40, 0.07) 0%,
      rgba(40, 40, 40, 0.07) 33.3%,
      rgba(214, 214, 214, 0.07) 33.3%,
      rgba(214, 214, 214, 0.07) 66.6%,
      rgba(190, 190, 190, 0.07) 66.6%,
      rgba(190, 190, 190, 0.07) 99.89999999999999%
    ),
    linear-gradient(
      61deg,
      rgba(230, 230, 230, 0) 0%,
      rgba(230, 230, 230, 0) 33.3%,
      rgba(241, 241, 241, 0) 33.3%,
      rgba(241, 241, 241, 0) 66.6%,
      rgba(55, 55, 55, 0) 66.6%,
      rgba(55, 55, 55, 0) 99%
    ),
    linear-gradient(0deg, #2625e3, #0bbaef);
  background-attachment: fixed;
background-image: repeating-linear-gradient(139deg, hsla(298,16%,68%,0.06) 0px, hsla(298,16%,68%,0.06) 1px,transparent 1px, transparent 21px,hsla(298,16%,68%,0.06) 21px, hsla(298,16%,68%,0.06) 22px,transparent 22px, transparent 72px),repeating-linear-gradient(49deg, hsla(298,16%,68%,0.06) 0px, hsla(298,16%,68%,0.06) 1px,transparent 1px, transparent 21px,hsla(298,16%,68%,0.06) 21px, hsla(298,16%,68%,0.06) 22px,transparent 22px, transparent 72px),repeating-linear-gradient(184deg, hsla(298,16%,68%,0.06) 0px, hsla(298,16%,68%,0.06) 1px,transparent 1px, transparent 21px,hsla(298,16%,68%,0.06) 21px, hsla(298,16%,68%,0.06) 22px,transparent 22px, transparent 72px),linear-gradient(139deg, rgb(126,195,9),rgb(126,195,9));
background-image: repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(157.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),linear-gradient(270deg, rgb(22,94,235),rgb(22,94,235));
background-image: repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(112.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(225deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(22.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(315deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(157.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),repeating-linear-gradient(67.5deg, hsla(264,0%,88%,0.03) 0px, hsla(264,0%,88%,0.03) 1px,transparent 1px, transparent 12px),linear-gradient(270deg, rgb(40,147,220),rgb(40,147,220));
}

/* body {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  color: white;
  margin: 0px;
  text-align: center;

  background: linear-gradient(
      71deg,
      rgba(55, 55, 55, 0.03) 0%,
      rgba(55, 55, 55, 0.03) 16.667%,
      rgba(111, 111, 111, 0.03) 16.667%,
      rgba(111, 111, 111, 0.03) 33.334%,
      rgba(230, 230, 230, 0.03) 33.334%,
      rgba(230, 230, 230, 0.03) 50.001000000000005%,
      rgba(129, 129, 129, 0.03) 50.001%,
      rgba(129, 129, 129, 0.03) 66.668%,
      rgba(77, 77, 77, 0.03) 66.668%,
      rgba(77, 77, 77, 0.03) 83.33500000000001%,
      rgba(190, 190, 190, 0.03) 83.335%,
      rgba(190, 190, 190, 0.03) 100.002%
    ),
    linear-gradient(
      281deg,
      rgba(176, 176, 176, 0.03) 0%,
      rgba(176, 176, 176, 0.03) 16.667%,
      rgba(192, 192, 192, 0.03) 16.667%,
      rgba(192, 192, 192, 0.03) 33.334%,
      rgba(74, 74, 74, 0.03) 33.334%,
      rgba(74, 74, 74, 0.03) 50.001000000000005%,
      rgba(169, 169, 169, 0.03) 50.001%,
      rgba(169, 169, 169, 0.03) 66.668%,
      rgba(34, 34, 34, 0.03) 66.668%,
      rgba(34, 34, 34, 0.03) 83.33500000000001%,
      rgba(5, 5, 5, 0.03) 83.335%,
      rgba(5, 5, 5, 0.03) 100.002%
    ),
    linear-gradient(
      196deg,
      rgba(98, 98, 98, 0.03) 0%,
      rgba(98, 98, 98, 0.03) 16.667%,
      rgba(208, 208, 208, 0.03) 16.667%,
      rgba(208, 208, 208, 0.03) 33.334%,
      rgba(63, 63, 63, 0.03) 33.334%,
      rgba(63, 63, 63, 0.03) 50.001000000000005%,
      rgba(180, 180, 180, 0.03) 50.001%,
      rgba(180, 180, 180, 0.03) 66.668%,
      rgba(200, 200, 200, 0.03) 66.668%,
      rgba(200, 200, 200, 0.03) 83.33500000000001%,
      rgba(59, 59, 59, 0.03) 83.335%,
      rgba(59, 59, 59, 0.03) 100.002%
    ),
    linear-gradient(
      35deg,
      rgba(233, 233, 233, 0.03) 0%,
      rgba(233, 233, 233, 0.03) 16.667%,
      rgba(26, 26, 26, 0.03) 16.667%,
      rgba(26, 26, 26, 0.03) 33.334%,
      rgba(186, 186, 186, 0.03) 33.334%,
      rgba(186, 186, 186, 0.03) 50.001000000000005%,
      rgba(162, 162, 162, 0.03) 50.001%,
      rgba(162, 162, 162, 0.03) 66.668%,
      rgba(254, 254, 254, 0.03) 66.668%,
      rgba(254, 254, 254, 0.03) 83.33500000000001%,
      rgba(245, 245, 245, 0.03) 83.335%,
      rgba(245, 245, 245, 0.03) 100.002%
    ),
    linear-gradient(
      294deg,
      rgba(157, 157, 157, 0.01) 0%,
      rgba(157, 157, 157, 0.01) 12.5%,
      rgba(125, 125, 125, 0.01) 12.5%,
      rgba(125, 125, 125, 0.01) 25%,
      rgba(120, 120, 120, 0.01) 25%,
      rgba(120, 120, 120, 0.01) 37.5%,
      rgba(19, 19, 19, 0.01) 37.5%,
      rgba(19, 19, 19, 0.01) 50%,
      rgba(111, 111, 111, 0.01) 50%,
      rgba(111, 111, 111, 0.01) 62.5%,
      rgba(140, 140, 140, 0.01) 62.5%,
      rgba(140, 140, 140, 0.01) 75%,
      rgba(114, 114, 114, 0.01) 75%,
      rgba(114, 114, 114, 0.01) 87.5%,
      rgba(94, 94, 94, 0.01) 87.5%,
      rgba(94, 94, 94, 0.01) 100%
    ),
    linear-gradient(
      19deg,
      rgba(217, 217, 217, 0.02) 0%,
      rgba(217, 217, 217, 0.02) 20%,
      rgba(105, 105, 105, 0.02) 20%,
      rgba(105, 105, 105, 0.02) 40%,
      rgba(252, 252, 252, 0.02) 40%,
      rgba(252, 252, 252, 0.02) 60%,
      rgba(1, 1, 1, 0.02) 60%,
      rgba(1, 1, 1, 0.02) 80%,
      rgba(232, 232, 232, 0.02) 80%,
      rgba(232, 232, 232, 0.02) 100%
    ),
    linear-gradient(90deg, rgb(22, 94, 235), rgb(126, 195, 9));
  background-attachment: fixed;
}

h1 {
  margin: 0px;
  padding-top: 75px; 
  text-align: center;
  font-size: 20vw;
  text-shadow: 5px 5px black;
}
h2 {
  margin: 0px;
  padding-top: 0px; 
  text-align: center;
  font-size: 15vw;
  text-shadow: 5px 5px black;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 120px;
  line-height: 120px;
  padding-bottom: 40px;
}
main {
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

ul {
  padding-left: 30px;
  padding-right: 30px;
  list-style-type: none;
  text-align: center;
}
ul li {
  line-height: 51px;

  background-color: rgba(255, 255, 255, 0.5);

  font-size: 50px;
  text-shadow: 3px 3px 0px black;
  box-shadow: 0px 0px 30px black;

  display: block;
  margin: 50px;
  border-radius: 15px;
  transition: 0.3s;
}
ul li:hover {
  background-color: rgba(255, 255, 255, 0.75);
}
ul li a {
  display: block;
  padding: 30px 30px;
}
ul li a .SmallProject {
  padding: 300px;
}

a {
  color: white;
  text-decoration: none;
  transition: 0.3s;

  margin: 0px;
  padding: 0px;
}
a:hover {
  color: rgba(150, 150, 150, 1);
}

i {
  display: block;
  height: 0px;

  margin: 0px 25px;
  text-shadow: 0px 0px 30px black;
}
.fab {
  font-size: 100px;
}

.fa-angle-down {
  margin-top: 0;
}



.links {
  font-size: 100px;
  text-align: center;
}
.fa-youtube-square {
  font-size: 15vw; 
  margin: 0px 3vw;
}
.fa-linkedin {
  font-size: 15vw; 
  margin: 0px 3vw;
}
.fa-itch-io {
  font-size: 15vw; 
  margin: 0px 3vw;
}
.fa-github-square {
  font-size: 15vw; 
  margin: 0px 3vw;
}
@media (min-width: 1000px) {
  h1 {
    text-align: center;
    font-size: 175px;
    text-shadow: 5px 5px black;
  }
  h2 {
    text-align: center;
    font-size: 125px;
    text-shadow: 5px 5px black;
  }
  ul li {
    display: inline-block;
    margin: 2%;
  }
  ul li a {
    min-width: 135px;
    display: inline-block;
    padding: 30px 13vw;
    font-size: 1em;
  }

  .links {
    font-size: 150px;
  }
  .fa-youtube-square {
    font-size: 180px;
    margin: 0px 25px;
  }
  .fa-linkedin {
    font-size: 180px;
    margin: 0px 25px;
  }
  .fa-itch-io {
    font-size: 180px;
    margin: 0px 25px;
  }
  .fa-github-square {
    font-size: 180px;
    margin: 0px 25px;
  }
}


.border {
  padding: 15px;
  background-color: #284e7a;
  background: linear-gradient(to top, black, #284e7a 100%);
}

.AboutSection {
  background: linear-gradient(
      52deg,
      rgba(163, 163, 163, 0.09) 0%,
      rgba(163, 163, 163, 0.09) 33.3%,
      rgba(100, 100, 100, 0.09) 33.3%,
      rgba(100, 100, 100, 0.09) 66.6%,
      rgba(162, 162, 162, 0.09) 66.6%,
      rgba(162, 162, 162, 0.09) 99%
    ),
    linear-gradient(
      258deg,
      rgba(193, 193, 193, 0.06) 0%,
      rgba(193, 193, 193, 0.06) 33.3%,
      rgba(169, 169, 169, 0.06) 33.3%,
      rgba(169, 169, 169, 0.06) 66.6%,
      rgba(92, 92, 92, 0.06) 66.6%,
      rgba(92, 92, 92, 0.06) 99%
    ),
    linear-gradient(
      129deg,
      rgba(45, 45, 45, 0.03) 0%,
      rgba(45, 45, 45, 0.03) 33.3%,
      rgba(223, 223, 223, 0.03) 33.3%,
      rgba(223, 223, 223, 0.03) 66.6%,
      rgba(173, 173, 173, 0.03) 66.6%,
      rgba(173, 173, 173, 0.03) 99%
    ),
    linear-gradient(
      280deg,
      rgba(226, 226, 226, 0.06) 0%,
      rgba(226, 226, 226, 0.06) 33.3%,
      rgba(81, 81, 81, 0.06) 33.3%,
      rgba(81, 81, 81, 0.06) 66.6%,
      rgba(186, 186, 186, 0.06) 66.6%,
      rgba(186, 186, 186, 0.06) 99%
    ),
    linear-gradient(
      85deg,
      rgba(225, 225, 225, 0.04) 0%,
      rgba(225, 225, 225, 0.04) 33.3%,
      rgba(95, 95, 95, 0.04) 33.3%,
      rgba(95, 95, 95, 0.04) 66.6%,
      rgba(39, 39, 39, 0.04) 66.6%,
      rgba(39, 39, 39, 0.04) 99%
    ),
    linear-gradient(
      128deg,
      rgba(184, 184, 184, 0.06) 0%,
      rgba(184, 184, 184, 0.06) 33.3%,
      rgba(0, 0, 0, 0.06) 33.3%,
      rgba(0, 0, 0, 0.06) 66.6%,
      rgba(140, 140, 140, 0.06) 66.6%,
      rgba(140, 140, 140, 0.06) 99.89999999999999%
    ),
    linear-gradient(
      323deg,
      rgba(40, 40, 40, 0.07) 0%,
      rgba(40, 40, 40, 0.07) 33.3%,
      rgba(214, 214, 214, 0.07) 33.3%,
      rgba(214, 214, 214, 0.07) 66.6%,
      rgba(190, 190, 190, 0.07) 66.6%,
      rgba(190, 190, 190, 0.07) 99.89999999999999%
    ),
    linear-gradient(
      61deg,
      rgba(230, 230, 230, 0) 0%,
      rgba(230, 230, 230, 0) 33.3%,
      rgba(241, 241, 241, 0) 33.3%,
      rgba(241, 241, 241, 0) 66.6%,
      rgba(55, 55, 55, 0) 66.6%,
      rgba(55, 55, 55, 0) 99%
    ),
    linear-gradient(0deg, #2625e3, #0bbaef);
      background-attachment: fixed;
}
.returnToTop {
  font-size: 100px;
  padding-top: 25px;
  text-align: center;
}

ol {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  line-height: 500px;
  height: 500px;
}
ol li {
  list-style-type: none;
}
.picture {
  list-style-type: none;
  border: 1px solid black;
  padding: 150px;
  background-image: url("./assets/thumbnail_IMG_3743.jpg");
  border-radius: 1000px;

  background-color: grey;
  background-repeat: no-repeat;

  background-size: cover;

  background-position: center;
  box-shadow: 0px 0px 30px black;

  overflow: hidden;
  margin-top: 30px;
  display: inline-block;
}
.InfoText {
  list-style-type: none;
  padding: 50px 25px;
  vertical-align: text-bottom;
  line-height: normal;
}
.lockedSize {
  height: 650px;
  overflow: visible;
}
.Info {
  margin: 50px 100px;
  font-size: 40px;
  text-shadow: 2px 2px 0px black;
  padding: 0;
}
.ProjectSection {
  background: linear-gradient(
      108deg,
      rgba(62, 62, 62, 0.09) 0%,
      rgba(62, 62, 62, 0.09) 30%,
      rgba(234, 234, 234, 0.09) 30%,
      rgba(234, 234, 234, 0.09) 100%
    ),
    linear-gradient(
      116deg,
      rgba(101, 101, 101, 0.06) 0%,
      rgba(101, 101, 101, 0.06) 51%,
      rgba(231, 231, 231, 0.06) 51%,
      rgba(231, 231, 231, 0.06) 100%
    ),
    linear-gradient(
      258deg,
      rgba(103, 103, 103, 0.07) 0%,
      rgba(103, 103, 103, 0.07) 1%,
      rgba(209, 209, 209, 0.07) 1%,
      rgba(209, 209, 209, 0.07) 100%
    ),
    linear-gradient(
      43deg,
      rgba(17, 17, 17, 0.09) 0%,
      rgba(17, 17, 17, 0.09) 7%,
      rgba(159, 159, 159, 0.09) 7%,
      rgba(159, 159, 159, 0.09) 100%
    ),
    linear-gradient(
      63deg,
      rgba(211, 211, 211, 0.1) 0%,
      rgba(211, 211, 211, 0.1) 94%,
      rgba(233, 233, 233, 0.1) 94%,
      rgba(233, 233, 233, 0.1) 100%
    ),
    linear-gradient(
      207deg,
      rgba(179, 179, 179, 0.1) 0%,
      rgba(179, 179, 179, 0.1) 57%,
      rgba(11, 11, 11, 0.1) 57%,
      rgba(11, 11, 11, 0.1) 100%
    ),
    linear-gradient(
      25deg,
      rgba(118, 118, 118, 0.07) 0%,
      rgba(118, 118, 118, 0.07) 98%,
      rgba(248, 248, 248, 0.07) 98%,
      rgba(248, 248, 248, 0.07) 100%
    ),
    linear-gradient(90deg, hsl(337, 90%, 49%), hsl(337, 90%, 49%));
}

.listOverride {
  width: 100%;
}

.listOverride ul {
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 0.2 0 calc(33.33% - 20px);
}
.listOverride li {
  flex: 0.2 0 calc(33.33% - 20px);
  display: list-item;
  margin: 20px;
}
.ONEBULLET {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.ILLUSION {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.RCCAR {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
}
.SpamAssassins {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Minecraft {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Owncloud {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.PCbuilds {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.CodeVanguards {
  background-blend-mode: darken;
  background-color: grey;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.listOverride a {
  height: 100px;
  width: 250px;
  padding: 10vh 7vw;
  font-size: 1em;
}

.smallText {
  text-shadow: 2px 2px black;
  font-size: 0.5em;
  line-height: 27.5px;
}
@media (max-width: 1000px) {
  .picture {
    padding: 15vw;
  }
  .Info {
    font-size: 5vw; 
  }

  .listOverride {
  }
  .listOverride ul {
    display: list-item;
  }

  .listOverride li {
    display: block;
    margin: 20px;
  }

  .listOverride a {
    height: 100px;
    width: auto;

    padding: 2.5vh 2vw;
    font-size: 6.5vw;
  }
  .smallText {
    text-shadow: 2px 2px black;
    font-size: 0.5em;
    padding-top: 10px;
  }
}

@media (max-height: 1000px) {
  main {
    height: 1000px;
  }
}

 */
footer {
  padding: 50px;
  background-color: #284e7a;
  background: linear-gradient(to bottom, black, #284e7a 100%);
}
.border {
  padding: 5px;
  background-color: #284e7a;
  background: linear-gradient(to top, black, #284e7a 100%);
}
</style>
